import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface BackAndPreviewProps {
  onBack: () => void;
}

export const BackAndPreview: React.FC<BackAndPreviewProps> = ({ onBack }) => (
  <div className="mb-4">
    <button
      type="button"
      onClick={onBack}
      className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
    >
      <ArrowLeft className="w-4 h-4" />
      Voltar
    </button>
  </div>
);
